import { VStack } from "@chakra-ui/react";
import { UseFormReturn } from "react-hook-form";
import { AutoFormField } from "models/autoForm";
import { FloatingFieldSize } from "design-system/components/FloatingField/context";
import FieldByType from "./FieldByType";

interface FormSectionProps {
  section: any;
  form: UseFormReturn<any>;
  size?: FloatingFieldSize;
}

function FormSection({ section, form, size, ...rest }: FormSectionProps) {
  return (
    <VStack spacing={4} {...rest}>
      {section.fields.map((field: AutoFormField) => (
        <FieldByType key={field.name} form={form} required={field.required || false} size={size} {...field} />
      ))}
    </VStack>
  );
}

export default FormSection;
